import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

export interface DeleteButtonProps {
  onClick: () => void;
  hasSelectedRows: boolean;
}

/**
 * Delete button component.
 * Enabled only when rows are selected.
 */
export function DeleteButton({ onClick, hasSelectedRows }: DeleteButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className={`p-2 hover:bg-red-50 ${
        hasSelectedRows 
          ? 'text-red-600 hover:text-red-700 hover:bg-red-100' 
          : 'text-gray-400 cursor-not-allowed'
      }`}
      onClick={hasSelectedRows ? onClick : undefined}
      title={hasSelectedRows ? "Delete selected rows" : "No rows selected"}
      disabled={!hasSelectedRows}
    >
      <Trash2 className="h-4 w-4" />
    </Button>
  );
}

export default DeleteButton;

